export default __webpack_public_path__ + "static/media/1946.cb38977a.png";